import React, { useEffect, useRef, useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { RiMenuFill, RiUser2Fill, RiCloseLargeFill } from "react-icons/ri";
import { RxTriangleDown } from "react-icons/rx";
import TL from "../Assets/TeleCourt.png";
import TL2 from "../Assets/TL2.png";
import { useAppContext } from "../../Contexts/AppContext";
import { useUserContext } from "../../Contexts/UserContext";
import { useNotificationContext } from "../../Contexts/NotificationContext";
import NotificationDialog  from "../dashboard/Notifications/NotificationDialogue";

const Header: React.FC = () => {
  const {
    isLoggedIn,
    isOpen,
    handleSignOut,
    toggleSidebar,
    isSidebarOpen,
    isLargeScreen,
    toggleDropdown,
    handleLinkClick,
  } = useAppContext();
  const { userData } = useUserContext();
  const { notifications, fetchNotifications } = useNotificationContext();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const sidebarRef = useRef<HTMLDivElement>(null);
  const unreadCount = notifications?.filter(notification => !notification.isRead).length;

  const [isVisible, setIsVisible] = useState(false);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
        toggleSidebar();
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        toggleDropdown();
      }
    },
    [toggleSidebar, toggleDropdown]
  );

  const handleToggle = () => {
    setIsVisible(!isVisible);
  };

  const togglePublicHearinDropdown = () => {
    setIsDropdownOpen(prevState => !prevState);
  };

  useEffect(() => {
    if (isSidebarOpen || isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen, isOpen, handleClickOutside]);

  // Refetch notifications when dropdown opens
  useEffect(() => {
    if (isOpen) {
      fetchNotifications();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header className="fixed top-0 left-0 w-full z-10 bg-[#222222] text-white py-4 px-10 border-b-4">
      <div
        className={`max-w-screen-xl ${isLargeScreen ? "mx-10" : "mx-auto sm:mx-10"} h-10 font-semibold flex items-center justify-between`}
      >
        <Link to="/">
          <img alt="logo" src={TL} height={67} width={120} />
        </Link>
        <div className="flex items-end" >
        {isLargeScreen && !isLoggedIn && (
          <nav className="hidden md:flex items-end space-x-10">
            <Link to={"/home"} className="text-l hover:underline">
              Home
            </Link>
            <Link to={"/about"} className="text-l hover:text-gray-300">
              About Us
            </Link>
            <Link to={"/mission"} className="text-l hover:text-gray-300">
              Mission
            </Link>
            <div className="relative">
              <button 
                onClick={togglePublicHearinDropdown} 
                className="flex flex-row items-end bg-[#222222] text-white p-0 h-8"
              >
                Public Hearing <RxTriangleDown className="ml-2" />
              </button>
              {isDropdownOpen && (
                <ul className="absolute mt-2 bg-gray-100 bg-opacity-90 text-black z-20 p-5 w-80 shadow-lg rounded-lg">
                  <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
                    <Link to={'/ongoing-sessions'}>Ongoing Sessions</Link>
                  </li>
                  <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
                    <Link to={'/upcoming-cases'}>Upcoming Cases</Link>
                  </li>
                  {/* <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
                    <Link to={'/past-recordings'}>Past Recordings</Link>
                  </li> */}
                </ul>
              )}
            </div>
          </nav>
        )}
          {!isLoggedIn ? (
            <Link
              to="/login"
              className={`text-white text-bold ${isLargeScreen ? "mr-10 h-10 px-5 min-w-fit flex items-end" : "text-sm mr-3"}`}
            >
              Register/Login
            </Link>
          ) : (
            <div className={`${isLargeScreen ? "ml-60 flex flex-row items-center" : "flex flex-row items-center"}`}>
              <span className="mr-2 hidden lg:block">
                Hello, {userData.userRole === 'JUDGE' 
                  ? `HON Justice ${userData.firstName ? userData.firstName[0] : ""} ${userData.middleName? userData.middleName[0] : ""}` 
                  : userData.userRole} 
                {` ${userData.lastName}`}
              </span> 
              <button onClick={toggleDropdown} className="flex flex-row bg-[#222222] text-white p-0 h-8 items-center">
                <RiUser2Fill className={`h-8 lg:h-10 ${unreadCount > 0 ? 'bg-red' : 'text-white'}`} />
                <RxTriangleDown className="h-8 lg:h-10" />
              </button>
              {isOpen && (
                <div
                  className="absolute mt-[280px] flex flex-col space-y-2 bg-gray-100 bg-opacity-80 text-black z-20 p-5 w-80 shadow-lg rounded-b-lg"
                  // ref={dropdownRef}
                  onClick={(e) => e.stopPropagation()}
                >
                  <NotificationDialog />
                  
                  <Link to="/edit-profile" onClick={handleLinkClick}>
                    Edit Profile
                  </Link>
                  <Link to={"/profile"} onClick={handleLinkClick}>
                    Profile
                  </Link>
                  <Link to={""} onClick={handleToggle}>
                    Settings
                  </Link>
                  <div className="relative w-full">
                    <ul
                      className={`absolute left-0 w-full bg-gray-100 bg-opacity-80 p-2 rounded-lg shadow-lg transition-opacity duration-300 ${
                        isVisible ? "opacity-100 visible" : "opacity-0 invisible"
                      }`}
                    >
                      <li>
                        <Link to={"/change-email"} onClick={handleLinkClick}>
                          Change Email
                        </Link>
                      </li>
                      <li>
                        <Link to={"/change-password"} onClick={handleLinkClick}>
                          Change Password
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <button onClick={() => { handleSignOut(); toggleDropdown(); }}>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          )}
          <Link to="#">
            <img alt="logo" src={TL2} className="h-[67.66px] lg:w-[70px]" />
          </Link>
          {!isLargeScreen && (
            <button className="lg:hidden" onClick={toggleSidebar}>
              {isSidebarOpen ? <RiCloseLargeFill className="h-8" /> : <RiMenuFill className="h-8" />}
            </button>
          )}
        </div>
      </div>
      {isSidebarOpen && !isLoggedIn && (
        <nav
          className={`fixed z-10 top-20 right-0 bg-opacity-80 h-full bg-white font-semibold text-black py-4 px-6 transition-transform duration-900 ${
            isSidebarOpen ? "w-1/2 transform translate-x-0" : "w-0 transform translate-x-full"
          } md:w-64`}
          style={{ width: isSidebarOpen ? "50%" : "0" }}
          ref={sidebarRef}
        >
          <ul className="space-y-2">
            <li className="border-b-lightbrown border-b py-2">
              <Link to="/home" className="text-l hover:text-gray-300" onClick={handleLinkClick}>
                Home
              </Link>
            </li>
            <li className="border-b-lightbrown border-b py-2">
              <Link to="/about" className="text-l hover:text-gray-300" onClick={handleLinkClick}>
                About Us
              </Link>
            </li>
            <li className="border-b-lightbrown border-b py-2">
              <Link to="/mission" className="text-l hover:text-gray-300" onClick={handleLinkClick}>
                Mission
              </Link>
            </li>
            <li className="border-b-lightbrown border-b py-2">
              <Link to="/ongoing-sessions" className="text-l hover:text-gray-300" onClick={handleLinkClick}>
                Ongoing Sessions
              </Link>
            </li>
            <li className="border-b-lightbrown border-b py-2">
              <Link to="/upcoming-cases" className="text-l hover:text-gray-300" onClick={handleLinkClick}>
                Upcoming Cases
              </Link>
            </li>
          </ul>
        </nav>
      )}
      {isSidebarOpen && isLoggedIn && (
        <nav
          className={`fixed z-10 top-20 right-0 bg-opacity-80 h-full bg-white font-semibold text-black py-4 px-6 transition-transform duration-900 ${
            isSidebarOpen ? "w-1/2 transform translate-x-0" : "w-0 transform translate-x-full"
          } md:w-64`}
          style={{ width: isSidebarOpen ? "50%" : "0" }}
          ref={sidebarRef}
        >
          <ul className="space-y-2">
            <li className="border-b-lightbrown border-b py-2">
              <Link to="/dashboard" className="text-l hover:text-gray-300" onClick={handleLinkClick}>
                My Dashboard
              </Link>
            </li>
            <li className="border-b-lightbrown border-b py-2">
              <Link to="/dashboard/court-schedule">{userData.userRole === 'COUNSEL' ? 'Court Schedule' : 'Cause List'}</Link>
            </li>
            {userData.userRole === "COUNSEL" && (
              <>
                <li className="border-b-lightbrown border-b py-2">
                  <Link to="/dashboard/virtual-court-application" className="text-l hover:text-gray-300" onClick={handleLinkClick}>
                    Apply for Virtual Court
                  </Link>
                </li>
                <li className="border-b-lightbrown border-b py-2">
                  <Link to="/dashboard/represent-litigant">
                    Represent a Litigant
                  </Link>
                </li>
                <li className="border-b-lightbrown border-b py-2">
                    <Link to="/dashboard/apply-for-ruling">Apply for Ruling</Link>
                </li>
                <li className="border-b-lightbrown border-b py-2">
                    <Link to="/dashboard/apply-for-judgement">Apply for Judgment</Link>
                </li>
                <li className="border-b-lightbrown border-b py-2">
                    <Link to="/dashboard/apply-for-records">Apply for Court Records</Link>
                </li>
              </>
            )}
            {userData.userRole === 'JUDGE' && (
              <>
                <li className="border-b-lightbrown border-b py-2">
                    <Link to="/dashboard/ruling-application">Applications for Ruling</Link>
                </li>
                <li className="border-b-lightbrown border-b py-2">
                    <Link to="/dashboard/Judgement-applications">Applications for Judgment</Link>
                </li>
                <li className="border-b-lightbrown border-b py-2">
                    <Link to="/dashboard/court-records-applications">Applications for Court Records</Link>
                </li>
              </>
            )}
            {/* <li className="border-b-lightbrown border-b py-2">
              <Link to="/dashboard/join-court-session" className="text-l hover:text-gray-300" onClick={handleLinkClick}>
                Join Court Session
              </Link>
            </li> */}
            <li className="border-b-lightbrown border-b py-2">
              <Link to='/ongoing-sessions'className="text-l hover:text-gray-300"onClick={handleLinkClick}>
                Ongoing Court Sessions
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Header;
